import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FolderShareIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.42 6.94H20.28V18.54H3.72V4.92H8.84C9.42 4.92 9.76 5.16 10.12 5.44L11.66 6.66C11.88 6.84 12.08 6.94 12.42 6.94ZM8.38 6.58H5.38V16.88H18.62V8.6H11.96C11.38 8.6 11.04 8.36 10.68 8.08L9.14 6.86C8.92 6.68 8.72 6.58 8.38 6.58ZM8.38 13.4V12.06H13.62L12.28 10.7L13.18 9.84L16.02 12.74L13.18 15.64L12.28 14.76L13.64 13.4H8.38Z" />
    </SvgIcon>
  );
});
